import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import "../style/services-usa/shopify-web-development/_banner.scss";
import BgImg from "../../images/services-usa/vendor-portal/banner-portal.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service shopify-banner overflow-x-hidden"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              {/* <h1 className="web_head_banner">Build Scalable Cloud Apps</h1> */}
              <h1 style={{ marginBottom: "15px" }}>
                Vendor Portal Development Company
              </h1>
              <p className="bottom-heading">
                Streamlined vendor management with custom portals
              </p>
              <p>
                With over 5 years of experience, TekRevol's vendor portals serve
                as all-in-one web solutions, offering companies, suppliers, and
                trading partners a centralized hub that enhances efficiency,
                simplifies workflows, and strengthens partnerships.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Discuss Your Project now!
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
